import { Achievement, AchievementProgress, Statistics } from '../types';

// All available achievements (~40 total) - default set
export const DEFAULT_ACHIEVEMENTS: Achievement[] = [
  // Milestone achievements (6)
  { id: 'first-hand', name: 'First Hand', description: 'Play your first hand', icon: '🎲', category: 'milestone', requirement: 1, metric: 'handsPlayed' },
  { id: 'hands-25', name: 'Getting Started', description: 'Play 25 hands', icon: '🃏', category: 'milestone', requirement: 25, metric: 'handsPlayed' },
  { id: 'hands-100', name: 'Card Counter', description: 'Play 100 hands', icon: '📊', category: 'milestone', requirement: 100, metric: 'handsPlayed' },
  { id: 'hands-500', name: 'Dedicated Player', description: 'Play 500 hands', icon: '🎯', category: 'milestone', requirement: 500, metric: 'handsPlayed' },
  { id: 'hands-1000', name: 'Professional', description: 'Play 1000 hands', icon: '🏆', category: 'milestone', requirement: 1000, metric: 'handsPlayed' },
  { id: 'hands-5000', name: 'Legend', description: 'Play 5000 hands', icon: '⭐', category: 'milestone', requirement: 5000, metric: 'handsPlayed' },

  // Gameplay achievements (10)
  { id: 'first-blackjack', name: 'Lucky!', description: 'Get your first blackjack', icon: '🍀', category: 'gameplay', requirement: 1, metric: 'blackjacks' },
  { id: 'blackjacks-10', name: 'Blackjack Master', description: 'Get 10 blackjacks', icon: '🎰', category: 'gameplay', requirement: 10, metric: 'blackjacks' },
  { id: 'blackjacks-50', name: 'Blackjack Legend', description: 'Get 50 blackjacks', icon: '💎', category: 'gameplay', requirement: 50, metric: 'blackjacks' },
  { id: 'wins-25', name: 'Winner', description: 'Win 25 hands', icon: '🏅', category: 'gameplay', requirement: 25, metric: 'handsWon' },
  { id: 'wins-100', name: 'Victorious', description: 'Win 100 hands', icon: '🏆', category: 'gameplay', requirement: 100, metric: 'handsWon' },
  { id: 'wins-500', name: 'Unstoppable', description: 'Win 500 hands', icon: '🔥', category: 'gameplay', requirement: 500, metric: 'handsWon' },
  { id: 'win-rate-55', name: 'Above Average', description: 'Achieve 55% win rate (50+ hands)', icon: '📈', category: 'gameplay', requirement: 55, metric: 'winRate' },
  { id: 'split-hands-10', name: 'Splitter', description: 'Play 10 split hands', icon: '✂️', category: 'gameplay', requirement: 10, metric: 'splitHandsPlayed' },
  { id: 'split-hands-50', name: 'Split Master', description: 'Play 50 split hands', icon: '✂️', category: 'gameplay', requirement: 50, metric: 'splitHandsPlayed' },
  { id: 'first-scenario', name: 'Scenario Student', description: 'Complete your first practice scenario', icon: '📚', category: 'gameplay', requirement: 1, metric: 'scenariosAttempted' },

  // Counting achievements (12)
  { id: 'streak-5', name: 'On a Roll', description: 'Get a 5 count streak', icon: '🔥', category: 'counting', requirement: 5, metric: 'bestStreak' },
  { id: 'streak-10', name: 'Perfect Memory', description: 'Get a 10 count streak', icon: '🧠', category: 'counting', requirement: 10, metric: 'bestStreak' },
  { id: 'streak-25', name: 'Counting Savant', description: 'Get a 25 count streak', icon: '🌟', category: 'counting', requirement: 25, metric: 'bestStreak' },
  { id: 'streak-50', name: 'Counting Legend', description: 'Get a 50 count streak', icon: '👑', category: 'counting', requirement: 50, metric: 'bestStreak' },
  { id: 'streak-100', name: 'Count Immortal', description: 'Get a 100 count streak', icon: '⭐', category: 'counting', requirement: 100, metric: 'bestStreak' },
  { id: 'accuracy-80', name: 'Good Counter', description: 'Achieve 80% count accuracy (25+ hands)', icon: '📈', category: 'counting', requirement: 80, metric: 'countAccuracy' },
  { id: 'accuracy-90', name: 'Sharp Counter', description: 'Achieve 90% count accuracy (50+ hands)', icon: '📈', category: 'counting', requirement: 90, metric: 'countAccuracy' },
  { id: 'accuracy-95', name: 'Expert Counter', description: 'Achieve 95% count accuracy (100+ hands)', icon: '💎', category: 'counting', requirement: 95, metric: 'countAccuracy' },
  { id: 'no-errors-10', name: 'Flawless', description: 'Get 10 perfect counts in a row', icon: '✨', category: 'counting', requirement: 10, metric: 'consecutiveCorrect' },
  { id: 'no-errors-25', name: 'Impeccable', description: 'Get 25 perfect counts in a row', icon: '✨', category: 'counting', requirement: 25, metric: 'consecutiveCorrect' },
  { id: 'deviations-master', name: 'Deviation Expert', description: 'Get 15 correct deviation calls', icon: '📊', category: 'counting', requirement: 15, metric: 'deviationCorrect' },
  { id: 'speed-drill-100', name: 'Speed Demon', description: 'Score 100+ on speed drill', icon: '⚡', category: 'counting', requirement: 100, metric: 'speedDrillHighScore' },

  // Betting achievements (10)
  { id: 'first-perfect-bet', name: 'Bet Wisely', description: 'Make your first perfect bet', icon: '🎯', category: 'betting', requirement: 1, metric: 'perfectBets' },
  { id: 'perfect-bets-10', name: 'Smart Bettor', description: 'Make 10 perfect bets', icon: '💰', category: 'betting', requirement: 10, metric: 'perfectBets' },
  { id: 'perfect-bets-50', name: 'Betting Expert', description: 'Make 50 perfect bets', icon: '💵', category: 'betting', requirement: 50, metric: 'perfectBets' },
  { id: 'perfect-bets-100', name: 'Betting Master', description: 'Make 100 perfect bets', icon: '💎', category: 'betting', requirement: 100, metric: 'perfectBets' },
  { id: 'bet-accuracy-80', name: 'Bet Accuracy 80%', description: 'Achieve 80% bet accuracy (25+ hands)', icon: '📊', category: 'betting', requirement: 80, metric: 'betSizingAccuracy' },
  { id: 'bet-accuracy-90', name: 'Bet Accuracy 90%', description: 'Achieve 90% bet accuracy (50+ hands)', icon: '📈', category: 'betting', requirement: 90, metric: 'betSizingAccuracy' },
  { id: 'bankroll-15000', name: 'High Roller', description: 'Reach $15,000 bankroll', icon: '💰', category: 'betting', requirement: 15000, metric: 'currentBankroll' },
  { id: 'bankroll-25000', name: 'Wealthy Gambler', description: 'Reach $25,000 bankroll', icon: '💵', category: 'betting', requirement: 25000, metric: 'currentBankroll' },
  { id: 'bankroll-50000', name: 'Casino Mogul', description: 'Reach $50,000 bankroll', icon: '🏦', category: 'betting', requirement: 50000, metric: 'currentBankroll' },
  { id: 'insurance-master', name: 'Insurance Ace', description: 'Get 10 correct insurance decisions', icon: '🛡️', category: 'betting', requirement: 10, metric: 'insuranceCorrect' },
];

// Legacy export
export const ACHIEVEMENTS = DEFAULT_ACHIEVEMENTS;

type ProgressExtras = {
  speedDrillHighScore?: number;
};

function getMetricValue(metric: string | undefined, statistics: Statistics, extras?: ProgressExtras): number {
  switch (metric) {
    case 'handsPlayed': return statistics.handsPlayed;
    case 'handsWon': return statistics.handsWon;
    case 'handsLost': return statistics.handsLost;
    case 'blackjacks': return statistics.blackjacks;
    case 'perfectBets': return statistics.perfectBets || 0;
    case 'winRate': return statistics.handsPlayed > 0 ? Math.round((statistics.handsWon / statistics.handsPlayed) * 100) : 0;
    case 'splitHandsPlayed': return statistics.splitHandsPlayed;
    case 'bestStreak': return statistics.bestStreak;
    case 'countAccuracy': return Math.round(statistics.countAccuracy || 0);
    case 'betSizingAccuracy': return Math.round(statistics.betSizingAccuracy || 0);
    case 'consecutiveCorrect': return statistics.consecutiveCorrect;
    case 'currentBankroll': return statistics.currentBankroll;
    case 'scenariosAttempted': return statistics.scenariosAttempted;
    case 'scenariosCorrect': return statistics.scenariosCorrect;
    case 'deviationCorrect': return statistics.scenariosByCategory['deviations']?.correct || 0;
    case 'insuranceCorrect': return statistics.scenariosByCategory['insurance']?.correct || 0;
    case 'speedDrillHighScore': return extras?.speedDrillHighScore || 0;
    case 'totalXP': return statistics.totalXP;
    default:
      return 0;
  }
}

function evaluateRequirement(metric: string | undefined, value: number, comparator: 'gte' | 'lte' | 'eq', statistics: Statistics, extras?: ProgressExtras): { current: number; met: boolean } {
  const current = getMetricValue(metric, statistics, extras);
  switch (comparator) {
    case 'lte':
      return { current, met: current <= value };
    case 'eq':
      return { current, met: current === value };
    case 'gte':
    default:
      return { current, met: current >= value };
  }
}

function computeAchievementProgress(
  achievement: Achievement,
  statistics: Statistics,
  achievements: AchievementProgress[],
  extras?: ProgressExtras
): { current: number; required: number; percentage: number; unlocked: boolean } {
  const existingProgress = achievements.find(a => a.achievementId === achievement.id);
  if (existingProgress?.unlocked) {
    return { current: achievement.requirement, required: achievement.requirement, percentage: 100, unlocked: true };
  }

  // Multi-requirement achievements (all criteria must pass)
  if (achievement.requirements && achievement.requirements.length > 0) {
    const results = achievement.requirements.map(r => evaluateRequirement(r.metric, r.value, r.comparator || 'gte', statistics, extras));
    const met = results.every(r => r.met);
    const current = results.reduce((sum, r) => sum + r.current, 0);
    const required = achievement.requirements.reduce((sum, r) => sum + r.value, 0);
    const percentage = met ? 100 : Math.min(100, required === 0 ? 0 : Math.round((current / required) * 100));
    return { current, required, percentage, unlocked: met };
  }

  // Metric-based achievements
  const currentByMetric = getMetricValue(achievement.metric, statistics, extras);
  if (achievement.metric) {
    // For accuracy-based achievements, require minimum attempts to prevent false positives
    const accuracyMetrics = ['countAccuracy', 'betSizingAccuracy', 'winRate'];
    if (accuracyMetrics.includes(achievement.metric)) {
      // Determine minimum attempts based on requirement thresholds
      let minAttempts = 10; // default minimum
      if (achievement.requirement >= 95) {
        minAttempts = 100; // 95%+ accuracy needs 100+ attempts
      } else if (achievement.requirement >= 90) {
        minAttempts = 50; // 90%+ accuracy needs 50+ attempts
      } else if (achievement.requirement >= 80) {
        minAttempts = 25; // 80%+ accuracy needs 25+ attempts
      }
      
      // For count accuracy, use countAttempts; for others, use handsPlayed
      const attemptCount = achievement.metric === 'countAccuracy' 
        ? (statistics.countAttempts || 0) 
        : statistics.handsPlayed;
      
      // Not enough attempts - show progress toward minimum instead
      if (attemptCount < minAttempts) {
        const attemptProgress = Math.min(100, Math.round((attemptCount / minAttempts) * 100));
        return { 
          current: attemptCount, 
          required: minAttempts, 
          percentage: attemptProgress, 
          unlocked: false 
        };
      }
    }
    
    const percentage = Math.min(100, Math.round((currentByMetric / achievement.requirement) * 100));
    return { current: currentByMetric, required: achievement.requirement, percentage, unlocked: currentByMetric >= achievement.requirement };
  }

  // Fallback to id-based cases for legacy definitions
  let current = 0;
  switch (achievement.id) {
    case 'first-hand':
    case 'hands-25':
    case 'hands-100':
    case 'hands-500':
    case 'hands-1000':
    case 'hands-5000':
      current = statistics.handsPlayed;
      break;
    case 'first-blackjack':
    case 'blackjacks-10':
    case 'blackjacks-50':
      current = statistics.blackjacks;
      break;
    case 'wins-25':
    case 'wins-100':
    case 'wins-500':
      current = statistics.handsWon;
      break;
    case 'win-rate-55':
      current = statistics.handsPlayed >= 50
        ? Math.round((statistics.handsWon / statistics.handsPlayed) * 100)
        : 0;
      break;
    case 'split-hands-10':
    case 'split-hands-50':
      current = statistics.splitHandsPlayed;
      break;
    case 'streak-5':
    case 'streak-10':
    case 'streak-25':
    case 'streak-50':
    case 'streak-100':
      current = statistics.bestStreak;
      break;
    case 'accuracy-80':
      current = (statistics.countAttempts || 0) >= 25 ? Math.round(statistics.countAccuracy) : 0;
      break;
    case 'accuracy-90':
      current = (statistics.countAttempts || 0) >= 50 ? Math.round(statistics.countAccuracy) : 0;
      break;
    case 'accuracy-95':
      current = (statistics.countAttempts || 0) >= 100 ? Math.round(statistics.countAccuracy) : 0;
      break;
    case 'no-errors-10':
    case 'no-errors-25':
      current = statistics.consecutiveCorrect;
      break;
    case 'first-perfect-bet':
    case 'perfect-bets-10':
    case 'perfect-bets-50':
    case 'perfect-bets-100':
      current = statistics.perfectBets;
      break;
    case 'bet-accuracy-80':
      current = statistics.handsPlayed >= 25 ? Math.round(statistics.betSizingAccuracy) : 0;
      break;
    case 'bet-accuracy-90':
      current = statistics.handsPlayed >= 50 ? Math.round(statistics.betSizingAccuracy) : 0;
      break;
    case 'bankroll-15000':
    case 'bankroll-25000':
    case 'bankroll-50000':
      current = statistics.currentBankroll;
      break;
    case 'first-scenario':
      current = statistics.scenariosAttempted;
      break;
    case 'deviations-master':
      current = statistics.scenariosByCategory['deviations']?.correct || 0;
      break;
    case 'insurance-master':
      current = statistics.scenariosByCategory['insurance']?.correct || 0;
      break;
    case 'speed-drill-100':
      current = extras?.speedDrillHighScore || 0;
      break;
  }

  const percentage = Math.min(100, Math.round((current / achievement.requirement) * 100));
  return { current, required: achievement.requirement, percentage, unlocked: current >= achievement.requirement };
}

/**
 * Get achievement progress for a definition (supports custom achievements)
 */
export function getAchievementProgressByDefinition(
  achievement: Achievement,
  statistics: Statistics,
  achievements: AchievementProgress[],
  extras?: ProgressExtras
): { current: number; required: number; percentage: number; unlocked: boolean } {
  return computeAchievementProgress(achievement, statistics, achievements, extras);
}

/**
 * Get achievement by ID
 */
export function getAchievement(id: string, list: Achievement[] = DEFAULT_ACHIEVEMENTS): Achievement | undefined {
  return list.find(a => a.id === id);
}

/**
 * Get progress for a specific achievement
 */
export function getAchievementProgress(
  achievementId: string, 
  statistics: Statistics,
  achievements: AchievementProgress[],
  list: Achievement[] = DEFAULT_ACHIEVEMENTS,
  extras?: ProgressExtras
): { current: number; required: number; percentage: number; unlocked: boolean } {
  const achievement = getAchievement(achievementId, list);
  if (!achievement) return { current: 0, required: 0, percentage: 0, unlocked: false };
  return computeAchievementProgress(achievement, statistics, achievements, extras);
}

/**
 * Get all achievements with progress
 */
export function getAllAchievementsWithProgress(
  statistics: Statistics,
  achievements: AchievementProgress[],
  list: Achievement[] = DEFAULT_ACHIEVEMENTS,
  extras?: ProgressExtras
): Array<Achievement & { progress: ReturnType<typeof getAchievementProgress> }> {
  return list.map(achievement => ({
    ...achievement,
    progress: getAchievementProgress(achievement.id, statistics, achievements, list, extras)
  }));
}

/**
 * Get recently unlocked achievements (within last hour)
 */
export function getRecentlyUnlocked(achievements: AchievementProgress[]): AchievementProgress[] {
  const oneHourAgo = Date.now() - 60 * 60 * 1000;
  return achievements
    .filter(a => a.unlocked && a.unlockedAt && a.unlockedAt > oneHourAgo)
    .sort((a, b) => (b.unlockedAt || 0) - (a.unlockedAt || 0));
}

/**
 * Get count of unlocked achievements
 */
export function getUnlockedCount(achievements: AchievementProgress[], list: Achievement[] = DEFAULT_ACHIEVEMENTS): { unlocked: number; total: number } {
  return {
    unlocked: achievements.filter(a => a.unlocked).length,
    total: list.length
  };
}

